import { ApplicationRoutes } from '../../../../../../application/constants/routes';
import { IAnalyticsPageHeaderBreadcrumb } from './AnalyticsPageHeader';

export const CREATE_ANALYTICS_ROOT_BREADCRUMB = (label: string): IAnalyticsPageHeaderBreadcrumb => ({
  label,
  link: ApplicationRoutes.Analytics,
});
